<div class="modal-wrapper">
    <div class="header-wrapper">
        <div class="title-wrapper">
            @if(modalContext?.isAlert){
                <div class="icon-wrapper">
                    <cwo-icon class="icon" [name]="iconNameType.warning"/>
                </div>
            }
            <span class="title">{{modalContext?.modalTitle}}</span>
        </div>
        <button class="button-undecorated" (click)="closeModal()" [ariaLabel]="ariaLabelForClose">
            <cwo-round-icon [iconName]="iconNameType.close" [size]="'medium'" />
        </button>
    </div>
    @if (modalContext?.modalMessage) {
        <span class="message" [innerHTML]="modalContext?.modalMessage"></span>
    }
    @if (modalContext?.modalContent){
        <ng-container [ngTemplateOutlet]="modalContext?.modalContent ?? null"></ng-container>
    }
    
    <div class="action-buttons-wrapper">
        <button class="button-accent action-button" (click)="confirmAction()">{{modalContext?.confirmButtonText}}</button>
        @if(modalContext?.secondaryAction){
            <button class="button-accent button-soft action-button" (click)="secondaryAction()">{{modalContext?.cancelButtonText}}</button>
        }
    </div>
</div>
